import React from 'react';
import { NextContext } from 'next';
import LayoutActionDispatcher from '../modules/commons/LayoutActionDispatcher';
import AboutContainer from '../components/about/Container';
import HEAD from 'next/head';

class About extends React.PureComponent {
  public static async getInitialProps(ctx: NextContext) {
    const { store, asPath } = ctx;

    const pageTitle = 'ラウンジとは？';
    const layoutAction = new LayoutActionDispatcher(store.dispatch);
    layoutAction.settingLayout({
      header: {
        showTitle: false,
        pageTitle,
      },
      breadcrumb: {
        data: [{ path: '', label: pageTitle }],
      },
      seo: {
        asPath,
        title: `${pageTitle} | ラウンジ | ナース専科`,
        description: 'ラウンジを快適にご利用いただくために初めての方はご一読ください。',
      },
    });
  }

  public render(): React.ReactNode {
    return (
      <main className="p-2 lg:w-7/12 lg:mt-1 lg:ml-auto lg:mr-3">
        <HEAD>
          <link href="https://cdn-nurse-senka-assets.nurse-senka.jp/css/tailwind.min.css" rel="stylesheet" />
          <link href="https://use.fontawesome.com/releases/v5.0.6/css/all.css" rel="stylesheet" />
        </HEAD>
        <AboutContainer />
      </main>
    );
  }
}

export default About;
